import storiesService from '@/services/';

export default {
  data() {
    return {
      diagnoses: [],
      mkbSearchValue: '',
      mkbOffset: 0,
      PER_PAGE_COUNT: 30,

      isInfiniteLoading: false,
      isEmitSrcLoading: false,
      isLastPage: false,
    };
  },

  watch: {
    async mkbSearchValue() {
      this.isEmitSrcLoading = true;

      try {
        this.mkbOffset = 0;
        this.diagnoses = [];
        this.isLastPage = false;

        await this.getMkbDiagnoses();
      } finally {
        this.isEmitSrcLoading = false;
      }
    },
  },

  methods: {
    async getMkbDiagnoses({ append = false } = {}) {
      const data = await storiesService.getMkbList({
        skip: this.mkbOffset,
        take: this.PER_PAGE_COUNT,
        pattern: this.mkbSearchValue,
      });

      this.diagnoses = append
        ? [...this.diagnoses, ...data]
        : data;

      if (data.length < this.PER_PAGE_COUNT) {
        this.isLastPage = true;
      } else {
        this.mkbOffset += this.PER_PAGE_COUNT;
      }
    },

    async loadMoreMkb() {
      if (this.isLastPage || this.isInfiniteLoading) return;

      this.isInfiniteLoading = true;

      try {
        await this.getMkbDiagnoses({ append: true });
      } finally {
        this.isInfiniteLoading = false;
      }
    },

    getMkbFromSearch(value) {
      this.mkbSearchValue = value;
    },
  },
};